import {
  CalendarDays,
  CheckCircle2,
  Fingerprint,
  IdCard,
  ShieldCheck,
  UserCheck,
} from "lucide-react";
import { Customer } from "../../../Redux/custmoer_auth/types";

const formatDate = (dateString?: string) => {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const getInitials = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");

const getAge = (dob?: string) => {
  if (!dob) return "N/A";
  const [year, month, day] = dob.split("-").map(Number);
  if (!year) return "N/A";
  const today = new Date();
  let age = today.getFullYear() - year;
  const monthDifference = today.getMonth() + 1 - month;
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < day)
  )
    age--;
  return age;
};

const DashboardCard = ({ user }: { user: Customer }) => {
  const displayName = user?.name || user?.fullName || "Salar Member";
  const initials = getInitials(displayName);
  const kycLinked = Boolean(user?.kycDetails);
  const kycClass = kycLinked
    ? "user-dashboard-kyc-approved"
    : "user-dashboard-kyc-pending";
  const inviterName =
    user?.inviterName || user?.invitorName || "—";
  const inviterCode =
    user?.inviterRegisterId || user?.myReferralId || "—";

  return (
    <article className="user-dashboard-profile-card">
      <div className="user-dashboard-profile-accent" />

      <div className="user-dashboard-profile-head">
        <div className="user-dashboard-profile-title">
          <div className="user-dashboard-profile-title-icon">
            <Fingerprint size={22} />
          </div>
          <div>
            <p className="user-dashboard-overline">
              PROFILE & VERIFICATION
            </p>
            <h2>Member profile</h2>
          </div>
        </div>
        <span className={`user-dashboard-kyc-chip ${kycClass}`}>
          <ShieldCheck size={15} />
          KYC {kycLinked ? "Linked" : "Not Linked"}
        </span>
      </div>

      <div className="user-dashboard-profile-identity">
        <div className="user-dashboard-profile-avatar-wrap">
          {user?.profilePicture ? (
            <img
              src={user.profilePicture}
              alt={displayName}
              className="user-dashboard-profile-avatar"
            />
          ) : (
            <span
              className="user-dashboard-profile-avatar user-dashboard-profile-avatar-initials"
              aria-label={`${displayName} initials`}
            >
              {initials}
            </span>
          )}
          <span className="user-dashboard-profile-avatar-check">
            <CheckCircle2 size={15} />
          </span>
        </div>
        <div className="user-dashboard-profile-name">
          <span>MEMBER IDENTITY</span>
          <h3>{displayName}</h3>
          <div className="user-dashboard-profile-reg">
            <IdCard size={15} />
            {user?.registerId || "—"}
          </div>
        </div>
      </div>

      <div className="user-dashboard-profile-meta">
        <div>
          <CalendarDays size={17} />
          <span>
            Member since
            <strong>{formatDate(user?.doj)}</strong>
          </span>
        </div>
        <div>
          <UserCheck size={17} />
          <span>
            Invited by
            <strong>{inviterName}</strong>
          </span>
        </div>
      </div>

      <div className="user-dashboard-profile-fields">
        <div>
          <span>Name</span>
          <strong>{displayName}</strong>
        </div>
        <div>
          <span>S/O</span>
          <strong>{user?.fatherName || "—"}</strong>
        </div>
        <div>
          <span>Date of Joining</span>
          <strong>{formatDate(user?.doj)}</strong>
        </div>
        <div>
          <span>Gender</span>
          <strong>{user?.gender || "—"}</strong>
        </div>
        <div>
          <span>Age</span>
          <strong>{getAge(user?.dob)}</strong>
        </div>
       
        <div>
          <span>Invitor Code</span>
          <strong>{inviterCode}</strong>
        </div>
        <div className="user-dashboard-profile-field-wide">
          <span>Invitor Name</span>
          <strong>{inviterName}</strong>
        </div>
        <div className="user-dashboard-profile-field-wide">
          <span>KYC Status</span>
          <strong className={`user-dashboard-inline-status ${kycClass}`}>
            <span />
            {kycLinked ? "Linked" : "Not Linked"}
          </strong>
        </div>
      </div>
    </article>
  );
};

export default DashboardCard;
